export default class LoginComponentController {}
